// The route + status cell on a collapsed log row.
//
// Extracted from `screens/admin-logs.tsx` so it can be rendered in a test —
// that screen pulls in half the app.

import { logRequestSummary } from '@/lib/log-line';

export function LogRequest({
  log,
}: {
  log: { route?: string | null; http_status?: number | null } | null | undefined;
}) {
  const summary = logRequestSummary(log);
  if (!summary) return null;
  return (
    <span className="log-req mono" title={summary.title}>
      {summary.status !== null && (
        <span className={`log-status log-status-${summary.tone}`}>{summary.status}</span>
      )}
      {summary.method && <span className="log-method">{summary.method}</span>}
      {summary.path && <span className="log-route-path">{summary.path}</span>}
    </span>
  );
}
